<template>
    <div
        v-for="(orderPrice, index) in orderPrices"
        :key="index"
        class="total-order-prices__content"
        :data-cy="`price-${index}`"
    >
        <v-row no-gutters class="total-order-prices__content-price info-text text-subtitle-2 text-no-wrap">
            <p v-if="index === 0 && title" class="total-order-prices__content-price-title">{{ $t(title) }}</p>
            <p class="ml-auto font-weight-bold">
                <slot v-if="index === 0" />
                {{ $filters.priceFormat(orderPrice.amount, orderPrice.currency) }}
            </p>
        </v-row>
        <div
            v-if="orderPrice.commission && (useIsShowCommissionAndNettoCheckbox || showCommissionAndNettoBlock)"
            class="total-order-prices__commissions d-flex flex-column"
        >
            <span class="commission-block commission-block--row">
                <span class="font-weight-regular"> {{ $t('commission') }}: </span>
                {{ $filters.priceFormat(orderPrice.commission, orderPrice.currency) }}
            </span>
            <span
                v-if="
                    isShowVATCommission &&
                    (vatCalculatedAmountByEachServiceBrutto || (index === 0 && vatCalculatedAmountByEachServiceNetto))
                "
                class="commission-block"
            >
                <span class="font-weight-regular"> {{ `${$t('commission')} VAT` }}: </span>
                {{
                    $filters.priceFormat(
                        vatCalculatedAmountByEachServiceBrutto || vatCalculatedAmountByEachServiceNetto,
                        orderPrice.currency
                    )
                }}
            </span>
            <span class="commission-block commission-block--row">
                <span class="font-weight-regular"> {{ $t('net_amount') }}: </span>
                {{ $filters.priceFormat(orderPrice.amount - orderPrice.commission, orderPrice.currency) }}
            </span>
            <span v-if="isShowNetValue" class="commission-block">
                <span class="font-weight-regular"> {{ $t('net_value') }}: </span>
                {{
                    $filters.priceFormat(
                        orderPrice.amount - orderPrice.commission - vatCalculatedAmountByEachServiceBrutto,
                        orderPrice.currency
                    )
                }}
            </span>
        </div>
    </div>
</template>
<script setup lang="ts">
    const props = defineProps<{
        title?: string
        orderPrices: any
        vatCalculatedAmountByEachServiceBrutto?: any
        vatCalculatedAmountByEachServiceNetto?: any
        isShowNetValue?: boolean
        isShowVATCommission?: boolean
        showCommissionAndNettoBlock?: boolean
    }>()

    const useIsShowCommissionAndNettoCheckbox = computed(() => {
        return persistentStore.commissionAndNettoCheckbox
    })
</script>
